import React, { useState } from "react";
import { Link } from "react-router-dom";
import useNavigation from "../../utils/useNavigation";
import Style from "../../components/leftNavigation/LeftNavigation.module.css";
import hamburger from "../../assets/svg/hamburger.svg";
import Home from "../../assets/svg/Home.svg";
import Resources from "../../assets/svg/Resources.svg";
import Clients from "../../assets/svg/Clients.svg";
import Projects from "../../assets/svg/Projects.svg";
import Meeting from "../../assets/svg/Meeting.svg";
import Settings from "../../assets/svg/Settings.svg";
import HomeFilled from "../../assets/svg/HomeFilled.svg";
import ResourcesFilled from "../../assets/svg/ResourcesFilled.svg";
import ClientsFilled from "../../assets/svg/ClientsFilled.svg";
import ProjectsFilled from "../../assets/svg/ProjectsFilled.svg";
import MeetingFilled from "../../assets/svg/MeetingFilled.svg";
import SettingsFilled from "../../assets/svg/SettingsFilled.svg";
import Chevron from "../../assets/svg/Chevron.svg";
import ChevronUp from "../../assets/svg/ChevronUp.svg";
import { useLocation } from "react-router";
import {
  getExpClients,
  getExpMeetings,
  getExpProjects,
  getExpRes,
  getNavExpand,
} from "../../store/selectors/general.selector";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip, makeStyles } from "@fluentui/react-components";
import {
  setResClients,
  setResExp,
  setResMeetings,
  setResProjects,
} from "../../store/actions/general.actions";
import { WandSparkles } from "lucide-react";
import { getLocalStorage, keys as localStorageKeys } from "../../utils/localStorageUtils";
// import {PopoverSurface} from "@fluentui/react-components";

const useStyles = makeStyles({
  Navtooltip: {
    backgroundColor: "#342C82",
    color: "#FFFFFF",
  },
});

const LeftNavigation = (props) => {
  const dispatch = useDispatch();

  const navExpand = useSelector(getNavExpand);
  const expRes = useSelector(getExpRes);
  const expClients = useSelector(getExpClients);
  const expMettings = useSelector(getExpMeetings);
  const expProjects = useSelector(getExpProjects);
  const location = useLocation();
  const isDefaultAdmin = getLocalStorage(localStorageKeys.HAS_DEFAULT_ADMIN_ROLE);
  const permissions = localStorage.getItem("permissions");
  const itemCssClasses = (type) => {
    if (location.pathname.includes(type))
      return `${Style.itemTitle} ${Style.selected}`;
    return Style.itemTitle;
  };

  /////////////////
  const [isHover, setIsHover] = useState("");

  const handleMouseOver = (val) => {
    setIsHover(val); // Set active on mouse over
  };

  const handleMouseOut = () => {
    setIsHover(""); // Reset active on mouse out
  };
  ///////////

  const styles = useStyles();

  return (
    <>
      {navExpand ? (
        // expanded-Nav---------------
        // <div className={`${Style.expanded} ${Style.expandedNav}`} style={{ height: '650px' }}>
        <div className={`${Style.expanded} ${Style.expandedNav}`}>
          <div
            className={`d-flex ${Style.itemExpanded} ${Style.ExpandedHamburger}`}
          >
            <img src={hamburger} alt="" onClick={props.handleNavExpand} />
          </div>
          <div className={Style.expandedNavScroll}>
            <div
              className={`${location.pathname.includes(`/dashboard`)
                ? Style.MainactiveWrapper
                : ""
                }`}
              onMouseOver={() => handleMouseOver("Dashboard")}
              onMouseOut={handleMouseOut}
            >
              <Link to={`/dashboard`}>
                <div
                  className={`${Style.dashboardItem} ${itemCssClasses(
                    `/dashboard`
                  )} d-flex align-items-center ${isHover === "Dashboard" ? Style.activeTabItem : ""
                    }`}
                >
                  <img
                    src={
                      location.pathname.includes(`/dashboard`)
                        ? HomeFilled
                        : Home
                    }
                    alt=""
                  />
                  <p
                    className={`${location.pathname.includes(`/dashboard`) &&
                      Style.activeTab
                      } text-xsm-300 `}
                  >
                    Dashboard
                  </p>
                </div>
              </Link>
            </div>

            <div
              className={`w-100 ${expRes ? Style.MainactiveWrapper : ""} ${location.pathname.includes(`/roles`) ||
                location.pathname.includes(`/resources`) ||
                // location.pathname.includes(`/shifts`) ||
                location.pathname.includes(`/resource-planner`) ||
                location.pathname.includes(`/resource-reports`)
                ? Style.MainactiveWrapper
                : ""
                }`}
            >
              <div
                className={`${Style.itemWrapper} d-flex justif-content-between  align-items-center cursor-pointer ${isHover === "Resourcess" ? Style.activeTabItem : ""}`}
                onClick={() => dispatch(setResExp(!expRes))}
              >
                <div
                  className={`${Style.itemExpanded} d-flex align-items-center `}
                  onMouseOver={() => handleMouseOver("Resourcess")}
                  onMouseOut={handleMouseOut}
                >
                  <img
                    src={
                      location.pathname.includes(`/roles`) ||
                        location.pathname.includes(`/resources`) ||
                        // location.pathname.includes(`/shifts`) ||
                        location.pathname.includes(`/resource-planner`) ||
                        location.pathname.includes(`/resource-reports`)
                        ? ResourcesFilled
                        : Resources
                    }
                    alt=""
                  />
                  <p
                    className={`${(location.pathname.includes(`/roles`) ||
                      location.pathname.includes(`/resources`) ||
                      location.pathname.includes(`/resource-planner`) ||
                      location.pathname.includes(`/resource-reports`)) &&
                      Style.activeTab
                      } text-xsm-300`}
                  >
                    Resources
                  </p>
                </div>
                <img
                  src={expRes ? ChevronUp : Chevron}
                  alt=""
                  className={Style.chevron}
                />
              </div>
              {expRes && (
                <div>
                  {isDefaultAdmin && (
                    <Link
                      to={`/roles`}
                      onMouseOver={() => handleMouseOver("Role")}
                      onMouseOut={handleMouseOut}
                      className={`${Style.itemTitle
                        } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Role" ? Style.activeTabItem : ""
                        }`}
                    // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                    >
                      <p
                        className={`${location.pathname.includes(`/roles`) &&
                          `${Style.activeTab} ${Style.activeTabItem}`
                          } ${Style.linkItem} mb-0`}
                      >
                        Roles
                      </p>
                    </Link>
                  )}
                  {isDefaultAdmin && (
                    <Link
                      to={`/resources`}
                      // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                      onMouseOver={() => handleMouseOver("Resources")}
                      onMouseOut={handleMouseOut}
                      className={`${Style.itemTitle
                        } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Resources" ? Style.activeTabItem : ""
                        }`}
                    >
                      <p
                        className={`${location.pathname.includes(`/resources`) &&
                          `${Style.activeTab} ${Style.activeTabItem}`
                          } ${Style.linkItem} mb-0 `}
                      >
                        Resources
                      </p>
                    </Link>
                  )}
                  {/*
                  isDefaultAdmin && (
                    <Link
                      to={`/shifts`}
                      // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                      onMouseOver={() => handleMouseOver("Shifts")}
                      onMouseOut={handleMouseOut}
                      className={`${Style.itemTitle
                        } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Shifts" ? Style.activeTabItem : ""
                        }`}
                    >
                      <p
                        className={`${location.pathname.includes(`/shifts`) &&
                          `${Style.activeTab} ${Style.activeTabItem}`
                          } ${Style.linkItem} mb-0 `}
                      >
                        Shifts
                      </p>
                    </Link>
                  )*/}
                  {permissions.includes("User.View") && (
                    <Link
                      to={`/resource-planner`}
                      // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                      onMouseOver={() => handleMouseOver("Planner")}
                      onMouseOut={handleMouseOut}
                      className={`${Style.itemTitle
                        } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Planner"
                          ? Style.activeTabItem
                          : ""
                        }`}
                    >
                      <p
                        className={`${location.pathname.includes(`/resource-planner`) &&
                          `${Style.activeTab} ${Style.activeTabItem}`
                          } ${Style.linkItem} mb-0 `}
                      >
                        Planner
                      </p>
                    </Link>
                  )}
                  {permissions.includes("User.View") && (
                    <Link
                      to={`/resource-reports`}
                      onMouseOver={() => handleMouseOver("Reports")}
                      onMouseOut={handleMouseOut}
                      className={`${Style.itemTitle
                        } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Reports" ? Style.activeTabItem : ""
                        }`}
                    >
                      <p
                        className={`${location.pathname.includes(`/resource-reportss`) &&
                          `${Style.activeTab} ${Style.activeTabItem}`
                          } ${Style.linkItem} mb-0 `}
                      >
                        Reports
                      </p>
                    </Link>
                  )}
                  <Link
                    to={`/timesheet`}
                    // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                    onMouseOver={() => handleMouseOver("TimeSheet")}
                    onMouseOut={handleMouseOut}
                    className={`${Style.itemTitle
                      } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "TimeSheet" ? Style.activeTabItem : ""
                      }`}
                  >
                    <p
                      className={`${location.pathname.includes(`/timesheet`) &&
                        `${Style.activeTab} ${Style.activeTabItem}`
                        } ${Style.linkItem} mb-0 `}
                    >
                      Timesheets
                    </p>
                  </Link>
                </div>
              )}
            </div>

            <div
              className={`w-100 ${expClients ? Style.MainactiveWrapper : ""} ${location.pathname.includes(`/clients`) ||
                location.pathname.includes(`/program`) ||
                location.pathname.includes(`/portfolio`)
                ? Style.MainactiveWrapper
                : ""
                }`}
            >
              {permissions.includes("Client.View") && (
                <div
                  className={`${Style.itemWrapper
                    } d-flex justif-content-between align-items-center cursor-pointer ${isHover === "ManageClients" ? Style.activeTabItem : ""
                    }`}
                  onClick={() => dispatch(setResClients(!expClients))}
                >
                  <div
                    className={`${Style.itemExpanded} d-flex align-items-center`}
                    onMouseOver={() => handleMouseOver("ManageClients")}
                    onMouseOut={handleMouseOut}
                  >
                    <img
                      src={
                        location.pathname.includes(`/clients`) ||
                          location.pathname.includes(`/program`) ||
                          location.pathname.includes(`/portfolio`)
                          ? ClientsFilled
                          : Clients
                      }
                      alt=""
                    />
                    <p className="text-xsm-300">Manage Clients</p>
                  </div>
                  <img
                    src={expClients ? ChevronUp : Chevron}
                    alt=""
                    className={Style.chevron}
                  />
                </div>
              )}
              {expClients && (
                <>
                  {permissions.includes("Client.View") && (
                    <div>
                      <Link
                        to={`/clients`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Clients")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Clients" ? Style.activeTabItem : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/clients`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Clients
                        </p>
                      </Link>
                      {/* <Link to={`/archived-clients`} className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}>
                  <p className={`${location.pathname.includes(`/archived-clients`) && Style.activeTab} ${Style.linkItem} mb-0`}>Archived Clients</p>
                </Link> */}
                    </div>
                  )}
                  {permissions.includes("Portfolio.View") && (
                    <div>
                      <Link
                        to={`/portfolio`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Portfolios")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Portfolios" ? Style.activeTabItem : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/portfolio`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Portfolios
                        </p>
                      </Link>
                    </div>
                  )}
                  {permissions.includes("Program.View") && (
                    <div>
                      <Link
                        to={`/program`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Programs")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Programs" ? Style.activeTabItem : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/program`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Programs
                        </p>
                      </Link>
                    </div>
                  )}
                </>
              )}
            </div>

            <div
              className={`w-100 ${expProjects ? Style.MainactiveWrapper : ""} ${location.pathname.includes(`/projects`) ||
                location.pathname.includes(`/scopeItems`) ||
                location.pathname.includes(`/changeRequests`) ||
                location.pathname.includes(`/risks`) ||
                location.pathname.includes(`/communications`) ||
                location.pathname.includes(`/budgets`)
                ? Style.MainactiveWrapper
                : ""
                }`}
            >
              {permissions.includes("Project.View") && (
                <div
                  className={`${Style.itemWrapper
                    } d-flex justif-content-between align-items-center cursor-pointer ${isHover === "projectManagement" ? Style.activeTabItem : ""
                    }`}
                  onClick={() => dispatch(setResProjects(!expProjects))}
                >
                  <div
                    className={`${Style.itemExpanded} d-flex align-items-center`}
                    onMouseOver={() => handleMouseOver("projectManagement")}
                    onMouseOut={handleMouseOut}
                  >
                    <img
                      src={
                        location.pathname.includes(`/projects`) ||
                          location.pathname.includes(`/scopeItems`) ||
                          location.pathname.includes(`/changeRequests`) ||
                          location.pathname.includes(`/risks`) ||
                          location.pathname.includes(`/communications`) ||
                          location.pathname.includes(`/budgets`)
                          ? ProjectsFilled
                          : Projects
                      }
                      alt=""
                    />
                    <p className="text-xsm-300">Project Management</p>
                  </div>
                  <img
                    src={expProjects ? ChevronUp : Chevron}
                    alt=""
                    className={Style.chevron}
                  />
                </div>
              )}
              {expProjects && (
                <>
                  {permissions.includes("Project.View") && (
                    <div>
                      <Link
                        to={`/projects`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Projects")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Projects" ? Style.activeTabItem : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/projects`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Projects
                        </p>
                      </Link>
                    </div>
                  )}
                  {/* {permissions.includes("Project.View") && (
                    <div>
                      <Link
                        to={`/scopeItems`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Scope Items")}
                        onMouseOut={handleMouseOut}
                        className={`${
                          Style.itemTitle
                        } p-0 d-flex text-xsm-300 font-family-imp-nav ${
                          isHover === "Scope Items" ? Style.activeTabItem : ""
                        }`}
                      >
                        <p
                          className={`${
                            location.pathname.includes(`/scopeItems`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                          } ${Style.linkItem} mb-0`}
                        >
                          Milestones
                        </p>
                      </Link>
                    </div>
                  )} */}
                  {permissions.includes("Project.View") && (
                    <div>
                      <Link
                        to={`/changeRequests`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Change Requests")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Change Requests"
                            ? Style.activeTabItem
                            : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/changeRequests`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Change Requests
                        </p>
                      </Link>
                    </div>
                  )}
                  {permissions.includes("Project.View") && (
                    <div>
                      <Link
                        to={`/risks`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Risk/Issues")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Risk/Issues" ? Style.activeTabItem : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/risks`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Risk/Issues
                        </p>
                      </Link>
                    </div>
                  )}
                  {permissions.includes("Project.View") && (
                    <div>
                      <Link
                        to={`/communications`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() =>
                          handleMouseOver("Communication Plans")
                        }
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Communication Plans"
                            ? Style.activeTabItem
                            : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/communications`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Communication Plans
                        </p>
                      </Link>
                    </div>
                  )}
                  {permissions.includes("Project.View") && (
                    <div>
                      <Link
                        to={`/budgets`}
                        // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                        onMouseOver={() => handleMouseOver("Budgets")}
                        onMouseOut={handleMouseOut}
                        className={`${Style.itemTitle
                          } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Budgets" ? Style.activeTabItem : ""
                          }`}
                      >
                        <p
                          className={`${location.pathname.includes(`/budgets`) &&
                            `${Style.activeTab} ${Style.activeTabItem}`
                            } ${Style.linkItem} mb-0`}
                        >
                          Budgets
                        </p>
                      </Link>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* {permissions.includes('Portfolio.View') && <div className={`${Style.itemWrapper} d-flex justif-content-between align-items-center cursor-pointer`} onClick={() => setExpPortfolios(!expPortfolios)}>
            <div className={`${Style.itemExpanded} d-flex align-items-center`}>
              <img src={location.pathname.includes(`/portfolio`) ? ProjectsFilled : Projects} alt="" />
              <p className='text-xsm-300'>Portfolio Management</p>
            </div>
            <img src={expProjects ? ChevronUp : Chevron} alt="" className={Style.chevron} />
          </div>}
          {expPortfolios && (
            permissions.includes('Portfolio.View') && <div>
              <Link to={`/portfolio`} className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}>
                <p className={`${location.pathname.includes(`/portfolio`) && Style.activeTab} ${Style.linkItem} mb-0`}>Portfolios</p>
              </Link>
            </div>
          )} */}
            {/* {permissions.includes('Program.View') && <div className={`${Style.itemWrapper} d-flex justif-content-between align-items-center cursor-pointer`} onClick={() => setExpPrograms(!expPrograms)}>
            <div className={`${Style.itemExpanded} d-flex align-items-center`}>
              <img src={location.pathname.includes(`/program`) ? ProjectsFilled : Projects} alt="" />
              <p className='text-xsm-300'>Program Management</p>
            </div>
            <img src={expProjects ? ChevronUp : Chevron} alt="" className={Style.chevron} />
          </div>}
          {expPrograms && (
            permissions.includes('Program.View') && <div>
              <Link to={`/program`} className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}>
                <p className={`${location.pathname.includes(`/program`) && Style.activeTab} ${Style.linkItem} mb-0`}>Programs</p>
              </Link>
            </div>
          )} */}

            <div
              className={`w-100 ${expMettings ? Style.MainactiveWrapper : ""} ${location.pathname.includes(`/meeting`) ||
                location.pathname.includes(`/meetings-registry`)
                ? Style.MainactiveWrapper
                : ""
                }`}
            >
              {permissions.includes("Meeting.View") && (
                <div
                  className={`${Style.itemWrapper
                    } d-flex justif-content-between align-items-center cursor-pointer ${isHover === "meetingManagement" ? Style.activeTabItem : ""
                    }`}
                  onClick={() => dispatch(setResMeetings(!expMettings))}
                >
                  <div
                    className={`${Style.itemExpanded} d-flex align-items-center`}
                    onMouseOver={() => handleMouseOver("meetingManagement")}
                    onMouseOut={handleMouseOut}
                  >
                    <img
                      src={
                        location.pathname.includes(`/meeting`) ||
                          location.pathname.includes(`/meetings-registry`)
                          ? MeetingFilled
                          : Meeting
                      }
                      alt=""
                    />
                    <p className="text-xsm-300">Meeting Management</p>
                  </div>
                  <img
                    src={expMettings ? ChevronUp : Chevron}
                    alt=""
                    className={Style.chevron}
                  />
                </div>
              )}

              {expMettings && permissions.includes("Meeting.View") && (
                <div>
                  <Link
                    to={`/meeting`}
                    // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                    onMouseOver={() => handleMouseOver("Meetings")}
                    onMouseOut={handleMouseOut}
                    className={`${Style.itemTitle
                      } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Meetings" ? Style.activeTabItem : ""
                      }`}
                  >
                    <p
                      className={`${location.pathname.includes(`/meeting`) &&
                        `${Style.activeTab}`
                        } ${Style.linkItem} mb-0`}
                    >
                      Meetings
                    </p>
                  </Link>
                  <Link
                    to={`/meetings-registry`}
                    // className={`${Style.itemTitle} p-0 d-flex text-xsm-300 font-family-imp`}
                    onMouseOver={() => handleMouseOver("Meetings Minutes")}
                    onMouseOut={handleMouseOut}
                    className={`${Style.itemTitle
                      } p-0 d-flex text-xsm-300 font-family-imp-nav ${isHover === "Meetings Minutes" ? Style.activeTabItem : ""
                      }`}
                  >
                    <p
                      className={`${location.pathname.includes(`/meetings-registry`) &&
                        `${Style.activeTab} ${Style.activeTabItem}`
                        } ${Style.linkItem} mb-0`}
                    >
                      Meetings Minutes
                    </p>
                  </Link>
                </div>
              )}
            </div>
            <div
              className={`${location.pathname.includes(`/ai-create`)
                ? Style.MainactiveWrapper
                : ""
                }`}
              onMouseOver={() => handleMouseOver("Create AI")}
              onMouseOut={handleMouseOut}
            >
              <Link to={`/ai-create`}>
                <div
                  className={`${Style.dashboardItem} ${itemCssClasses(
                    `/ai-create`
                  )} d-flex align-items-center ${isHover === "Create AI" ? Style.activeTabItem : ""
                    }`}
                >
                  <WandSparkles size={18} strokeWidth={1.5} color="#8F54BE" />
                  <p
                    className={`${Style.LinearGradientText} ${location.pathname.includes(`/ai-create`) && Style.activeTab
                      } text-xsm-300 `}
                  >
                    Create AI
                  </p>
                </div>
              </Link>
            </div>
            <div className={Style.expandedSeperator} />
            {isDefaultAdmin && (
              <>
                <div className={`d-flex ${Style.itemExpanded}`}>
                  <p className={`${Style.admin} text-xsm-600`}>Admin</p>
                </div>
                <div
                  className={`${location.pathname.includes(`/settings`)
                    ? Style.MainactiveWrapper
                    : ""
                    } ${isHover === "accountView" ? Style.activeTabItem : ""}`}
                  onMouseOver={() => handleMouseOver("accountView")}
                  onMouseOut={handleMouseOut}
                >
                  <Link to={`/settings`}>
                    <div
                      className={`${Style.dashboardItem} ${itemCssClasses(
                        `/settings`
                      )} d-flex align-items-center`}
                    >
                      <img
                        src={
                          location.pathname.includes(`/settings`)
                            ? SettingsFilled
                            : Settings
                        }
                        alt=""
                      />
                      <p
                        className={`${location.pathname.includes(`/settings`) &&
                          Style.activeTab
                          } mb-0 text-xsm-300`}
                      >
                        Settings
                      </p>
                    </div>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        // mini-Nav---------------
        <div className={`${Style.Wrapper} ${Style.collapseNav} min-nav-bar`}>
          <div className={`d-flex ${Style.hamburgerItem}`}>
            <img src={hamburger} alt="" onClick={props.handleNavExpand} />
          </div>
          <div className={Style.seperator} />
          <Tooltip
            withArrow
            positioning="after"
            relationship="label"
            content={{ children: "Dashboard", className: styles.Navtooltip }}
          >
            <div
              className={`d-flex ${location.pathname.includes(`/dashboard`) && Style.active
                } ${Style.item} anchor-mini-bar`}
            >
              <Link to={`/dashboard`}>
                <img
                  src={
                    location.pathname.includes(`/dashboard`) ? HomeFilled : Home
                  }
                  alt=""
                />
              </Link>
            </div>
          </Tooltip>
          <Tooltip
            withArrow
            positioning="after"
            relationship="label"
            content={{ children: "Resources", className: styles.Navtooltip }}
          >
            <div
              className={`d-flex ${location.pathname.includes(`/resources`) && Style.active
                } ${Style.item} anchor-mini-bar`}
            >
              <Link to={`/resources`}>
                <img
                  src={
                    location.pathname.includes(`/resources`)
                      ? ResourcesFilled
                      : Resources
                  }
                  alt=""
                />
              </Link>
            </div>
          </Tooltip>
          {permissions.includes("Client.View") && (
            <Tooltip
              withArrow
              positioning="after"
              relationship="label"
              content={{ children: "Clients", className: styles.Navtooltip }}
            >
              <div
                className={`d-flex ${location.pathname.includes(`/clients`) && Style.active
                  } ${Style.item} anchor-mini-bar`}
              >
                <Link to={`/clients`}>
                  <img
                    src={
                      location.pathname.includes(`/clients`)
                        ? ClientsFilled
                        : Clients
                    }
                    alt=""
                  />
                </Link>
              </div>
            </Tooltip>
          )}
          {permissions.includes("Project.View") && (
            <Tooltip
              withArrow
              positioning="after"
              relationship="label"
              content={{ children: "Projects", className: styles.Navtooltip }}
            >
              <div
                className={`d-flex ${location.pathname.includes(`/projects`) && Style.active
                  } ${Style.item} anchor-mini-bar`}
              >
                <Link to={`/projects`}>
                  <img
                    src={
                      location.pathname.includes(`/projects`)
                        ? ProjectsFilled
                        : Projects
                    }
                    alt=""
                  />
                </Link>
              </div>
            </Tooltip>
          )}
          {/* {permissions.includes('Portfolio.View') && (
            <Tooltip withArrow positioning="after" relationship="label" content={{ children: "Portfolio", className: styles.Navtooltip }}>
              <div className={`d-flex ${location.pathname.includes(`/portfolio`) && Style.active} ${Style.item} anchor-mini-bar`}>
                <Link to={`/portfolio`}>
                  <img src={location.pathname.includes(`/portfolio`) ? ProjectsFilled : Projects} alt="" />
                </Link>
              </div>
            </Tooltip>
          )}
          {permissions.includes('Program.View') && (
            <Tooltip withArrow positioning="after" relationship="label" content={{ children: "Program", className: styles.Navtooltip }}>
              <div className={`d-flex ${location.pathname.includes(`/program`) && Style.active} ${Style.item} anchor-mini-bar`}>
                <Link to={`/program`}>
                  <img src={location.pathname.includes(`/program`) ? ProjectsFilled : Projects} alt="" />
                </Link>
              </div>
            </Tooltip>
          )} */}
          {permissions.includes("Meeting.View") && (
            <Tooltip
              withArrow
              positioning="after"
              relationship="label"
              content={{ children: "Meeting", className: styles.Navtooltip }}
            >
              <div
                className={`d-flex ${location.pathname.includes(`/meeting`) && Style.active
                  } ${Style.item} anchor-mini-bar`}
              >
                <Link to={`/meeting`}>
                  <img
                    src={
                      location.pathname.includes(`/meeting`)
                        ? MeetingFilled
                        : Meeting
                    }
                    alt=""
                  />
                </Link>
              </div>
            </Tooltip>
          )}
          <Tooltip
            withArrow
            positioning="after"
            relationship="label"
            content={{ children: "Create AI", className: styles.Navtooltip }}
          >
            <div
              className={`d-flex ${location.pathname.includes(`/ai-create`) && Style.active
                } ${Style.item} anchor-mini-bar`}
            >
              <Link to={`/ai-create`}>
                <WandSparkles size={18} strokeWidth={1.5} color="#8F54BE" />
              </Link>
            </div>
          </Tooltip>
          <div className={Style.seperator} />
          {isDefaultAdmin && (
            <Tooltip
              withArrow
              positioning="after"
              relationship="label"
              content={{ children: "Settings", className: styles.Navtooltip }}
            >
              <div
                className={`d-flex ${location.pathname.includes(`/settings`) && Style.active
                  } ${Style.item} anchor-mini-bar`}
              >
                <Link to={`/settings`}>
                  <img
                    src={
                      location.pathname.includes(`/settings`)
                        ? SettingsFilled
                        : Settings
                    }
                    alt=""
                  />
                </Link>
              </div>
            </Tooltip>
          )}
        </div>
      )}
    </>
  );
};

export default LeftNavigation;
